import AbstractMediator from "../../../../core/ui/AbstractMediator";
export default class DashboardTabMediator extends AbstractMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
    }

    initialize() {
        super.initialize();
    }

    destroy() {
        super.destroy();
    }

    show() {
        this._target.alpha = 1;
    }

    hide() {
        this._target.alpha = 0;
    }

    get skin() {
        return this._target;
    }
}